<template>
    <div style="width:100%;height:100%;">
        <div class="title">
        <!-- <p>离心机状态</p> -->
        <div class="btn">
            <span class="btnone" @click="echartsOneSwitch">
            <!-- <el-button size="small" type="primary">Primary</el-button> -->
            <button class="buttonone" >离心机阀门 %</button>
            </span>
            <span class="btntwo" @click="echartsTwoSwitch">
            <!-- <el-button size="small" type="primary">Primary</el-button> -->
            <button class="buttontwo" >离心机轴振 um</button>
            </span>
        </div>
        </div>
        <div class="echarts">
            <div id="rightThreeEcharts" style="width:100%;height:100%" v-show="echartsones" >
            </div>
            <div id="rightTwoEcharts" style="width:100%;height:100%" v-show="echartstwos" >
            </div>

        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import DataService from '@/api/data'
import { utils } from "@/utils/index.js";
var weChart
var myChart
    export default {
        
        data() {
            return {
              switch:true,
              echartsones:true,
              echartstwos:false,
              serialNumber:'',
              equipmentModel:'',
              chartsData:[],
              chartsTime:[],
              date:[],
              time_interval:'0'
            }
        },
        methods: {
          //获取趋势图数据
		  getTrendChart(){
              let list
            if(this.echartsones == true){
                if(this.equipmentModel == 'centrifuge_old'){
                    list = ['var40021','var40022']
                }else{
                    list = ['var40001','var40002']
                }
            }else{
                if(this.equipmentModel == 'centrifuge_old'){
                    list = ['var40026','var40027','var40028']
                }else{
                    list = ['var40012','var40013','var40014']
                }
            }
			DataService.trendChartOf3D({
				list:list,
				serialNumber:this.serialNumber,
				equipmentModel:this.equipmentModel,
				startTime:this.date[0],
				endTime:this.date[1],
			}).then(res=>{
				if(res.data != null){
                    this.chartsData = res.data.namedate
					this.chartsTime = res.data.time
                    if(this.echartsones == true){
					    this.rightThreeEcharts();
                    }else{
					    this.rightTwoEcharts();
                    }
				}
			}).catch(err=>{
				this.$message.error(err.message)
			})
		  },
		  time_intervalChange(){
			const endTime = utils.formatDate(new Date().getTime())
			switch (this.time_interval) {
				case '0':
				this.date = [utils.formatDate(new Date().getTime()-600000),endTime];
				break;
				case '1':
				this.date = [utils.formatDate(new Date().getTime()-3600000),endTime];
				break;
				case '2':
				this.date = [utils.formatDate(new Date().getTime()-7200000),endTime];
				break;
				case '3':
				this.date = [utils.formatDate(new Date().getTime()-10800000),endTime];
				break;
				case '4':
				this.date = [utils.formatDate(new Date().getTime()-14400000),endTime];
				break;
				case '5':
				this.date = [utils.formatDate(new Date().getTime()-28800000),endTime];
				break;
				case '6':
				this.date = [utils.formatDate(new Date().getTime()-43200000),endTime];
				break;
				default:
				this.date = [utils.formatDate(new Date().getTime()-600000),endTime];
				break;
			}
			this.getTrendChart()
		  },
          echartsTwoSwitch(){
            let famen=document.querySelector('.buttonone')
            famen.style.backgroundColor='#176282'
            let zhouzhen=document.querySelector('.buttontwo')
            zhouzhen.style.backgroundColor='#1d4e61'
            if(this.switch==true){
              this.echartsones=false
              this.echartstwos=true
              this.$nextTick(() => {
                this.getTrendChart() // 渲染操作
            })
              this.switch=false
            }

          },
          echartsOneSwitch(){
            let zhouzhen=document.querySelector('.buttontwo')
            zhouzhen.style.backgroundColor='#176282'
            let famen=document.querySelector('.buttonone')
            famen.style.backgroundColor='#1d4e61'
            if(this.switch==false){
              this.echartstwos=false
              this.echartsones=true
              this.$nextTick(() => {
                this.getTrendChart() // 渲染操作
            })

              this.switch=true
            }
          },

          rightThreeEcharts(){
                echarts.init(document.getElementById('rightThreeEcharts')).dispose()
                weChart = echarts.init(document.getElementById('rightThreeEcharts'))
                var charts = {
    // unit: '%',
    names: ['导叶阀开度', '放空阀开度'],
    lineX: this.chartsTime.map(function (str) {
                return str.slice(-8);
            }),
    value: [this.chartsData['导叶阀开度(%)'],this.chartsData['放空阀开度(%)']]

}
var color = ['rgba(23, 255, 243', 'rgba(255,100,97']
var lineY = []

for (var i = 0; i < charts.names.length; i++) {
    var x = i
    if (x > color.length - 1) {
        x = color.length - 1
    }
    var data = {
        name: charts.names[i],
        type: 'line',
        color: color[x] + ')',
        smooth: true,
        areaStyle: {
            normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: color[x] + ', 0.3)'
                }, {
                    offset: 0.8,
                    color: color[x] + ', 0)'
                }], false),
                shadowColor: 'rgba(0, 0, 0, 0.1)',
                shadowBlur: 10
            }
        },
        symbol: 'circle',
        symbolSize: 5,
        data: charts.value[i]
    }
    lineY.push(data)
}

lineY[0].markLine = {
    silent: true,
    data: [
    //     {
    //     yAxis: 5
    // }, {
    //     yAxis: 100
    // }, {
    //     yAxis: 200
    // }, {
    //     yAxis: 300
    // }, {
    //     yAxis: 400
    // }
]
}
weChart.setOption({
  dataZoom: [
          {
            start: 0,
            end: 100,
            //  startValue:50,
            //  endValue:100,
            type: "inside",
          },
        ],
    // backgroundColor:'#1b2735',
    tooltip: {
        trigger: 'axis'
    },
    // legend: {
    //     data: charts.names,
    //     itemHeight: 11,
    //       itemWidth:18,
    //     textStyle: {
    //         fontSize: 11,
    //         color: 'rgb(0,253,255,0.6)'
    //         // color: 'rgba(255,255,255,0.5)'
    //     },
    //     left: '1%'
    // },
    grid: {
        top: '19%',
        left: '2%',
        right: '4%',
        bottom: '-2%',
        containLabel: true
    },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        data: charts.lineX,
        axisLabel: {
            textStyle: {
                color: 'rgb(0,253,255,0.6)'
            },
            formatter: function(params) {
              // return params.split(' ')[0] + '\n' + params.split(' ')[1]
                return params.split(' ')[0] + '\n' 
            }
        }
    },
    yAxis: {
        name: charts.unit,
        min: 0,
		max: 100,
		interval: 25,
        nameTextStyle: {
      padding: [1, 1, -6, -35]
    },
        type: 'value',
        axisLabel: {
            formatter: '{value}',
            textStyle: {
                color: 'rgb(0,253,255,0.6)'
            }
        },
        splitLine: {
            lineStyle: {
                color: 'rgb(23,255,243,0.3)'
            }
        },
        axisLine: {
            lineStyle: {
                color: 'rgb(0,253,255,0.6)'
            }
        }
    },
    series: lineY
},true)
// setInterval(() => {
//   weChart.setOption({
//       legend: {
//         selected: {
//           '导叶阀开度': false,
//           '放空阀开度': false
//         }
//       }
//     })
//     weChart.setOption({
//       legend: {
//         selected: {
//           '导叶阀开度': true,
//           '放空阀开度': true
//         }
//       }
//     })
// },30000)
           },
           rightTwoEcharts(){
                echarts.init(document.getElementById('rightTwoEcharts')).dispose()
                myChart = echarts.init(document.getElementById('rightTwoEcharts'))
                myChart.setOption({
                    dataZoom: [
          {
            start: 0,
            end: 100,
            //  startValue:50,
            //  endValue:100,
            type: "inside",
          },
        ],
    // backgroundColor: '#394056',
    title: {
        // text: 'um',
        textStyle: {
            fontWeight: 'normal',
            fontSize: 15,
            color: '#dddddd '
            // color: '#F1F1F3'
        },
        left: '2%',
        top:'25'
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            lineStyle: {
                color: '#dddddd'
            }
        }
    },
    // legend: {
    //     icon: 'rect',
    //     itemWidth: 14,
    //     itemHeight: 5,
    //     itemGap: 13,
    //     data: ['一级轴振动', '二级轴振动', '三级轴振动','四级轴振动'],
    //     left: '2%',
    //     textStyle: {
    //         fontSize: 12,
    //         color: '#F1F1F3'
    //     }
    // },
    grid: {
        top:'30%',
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    xAxis: [{
        type: 'category',
        boundaryGap: false,
        axisLine: {
            lineStyle: {
                color: '#dddddd'
            }
        },
        data: this.chartsTime.map(function (str) {
                return str.substring(10,19);
            }),
    }],
    yAxis: [{
        type: 'value',
        min: 0,
		max: 150,
		interval: 50,
        axisTick: {
            show: false
        },
        axisLine: {
            lineStyle: {
                color: '#dddddd'
            }
        },
        axisLabel: {
            margin: 10,
            textStyle: {
                fontSize: 14
            }
        },
        splitLine: {
            lineStyle: {
                color: '#57617B'
            }
        }
    }],
    series: [{
        name: '一级轴振动',
        stack: '1',
        type: 'line',
        smooth: true,
        lineStyle: {
            normal: {
                width: 1
            }
        },
        areaStyle: {
            normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(137, 189, 27, 0.2)'
                }, {
                    offset: 0.8,
                    color: 'rgba(137, 189, 27, 0)'
                }], false),
                shadowColor: 'rgba(0, 0, 0, 0.1)',
                shadowBlur: 10
            }
        },
        itemStyle: {
            normal: {
                color: 'rgb(137,189,27)'
            }
        },
        data: this.chartsData['一级轴振动(μm)']
    }, {
        name: '二级轴振动',
        type: 'line',
        stack: '2',
        smooth: true,
        lineStyle: {
            normal: {
                width: 1
            }
        },
        areaStyle: {
            normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(0, 136, 212, 0.3)'
                }, {
                    offset: 0.8,
                    color: 'rgba(0, 136, 212, 0)'
                }], false),
                shadowColor: 'rgba(0, 0, 0, 0.1)',
                shadowBlur: 10
            }
        },
        itemStyle: {
            normal: {
                color: 'rgb(0,136,212)'
            }
        },
        data: this.chartsData['二级轴振动(μm)']
    }, {
        name: '三级轴振动',
        type: 'line',
        stack: '3',
        smooth: true,
        lineStyle: {
            normal: {
                width: 1
            }
        },
        areaStyle: {
            normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(219, 50, 51, 0.3)'
                }, {
                    offset: 0.8,
                    color: 'rgba(219, 50, 51, 0)'
                }], false),
                shadowColor: 'rgba(0, 0, 0, 0.1)',
                shadowBlur: 10
            }
        },
        itemStyle: {
            normal: {
                color: 'rgb(219,50,51)'
            }
        },
        data: this.chartsData['三级轴振动(μm)']
    }, ]
},true);

            }


        },
        created(){
            if(this.$route.query.serial_number){
                this.serialNumber = this.$route.query.serial_number;
                this.equipmentModel = this.$route.query.equipment_model;
            }
        },
        mounted () {
            if(sessionStorage.getItem('time_interval')){
                this.time_interval = sessionStorage.getItem('time_interval')
            }
            this.time_intervalChange()
           this.rightThreeEcharts()
           this.rightTwoEcharts()
           window.addEventListener("resize", () => {
            echarts.init(document.getElementById("rightThreeEcharts")).resize();
            });
            window.addEventListener("resize", () => {
            echarts.init(document.getElementById("rightTwoEcharts")).resize();
           });
           this.interval = setInterval(this.time_intervalChange, 30000);
        },
        beforeDestroy() {
    clearInterval(this.interval);
  },
    }
</script>

<style  scoped>
*{
    margin: 0;
    padding: 0;
}
.title{
    width: 100%;
    height: 9%;
    display: flex;
    align-items: center;
    background: url(../../assets/img/centrifuge/title.png) no-repeat;
    background-size: 100% 100%;
}
/* .title p{
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
   font-size: .8vw;
   color: white;
   margin-left:2vw;
} */
.btn{
    display: flex;
    align-items: center;
    /* justify-content: space-around; */
    /* margin-top: .5%; */
    width: 100%;
    height: 70%;
    margin-left: 2vw;
    /* background-color:red; */
}
.btnone{
    text-align: center;
    height: 100%;
    width: 130px; 
    /* background-color: aqua; */
}
.buttonone{
  display: flex;
  align-items: center;
  justify-content: center;
    height: 100%;
    width: 100%;
    color:white;
    background-color: #1d4e61;
    border: 0;
    border-radius: 2px;
    font-size:.6vw;
    cursor: pointer;
}
.btntwo{
    text-align: center;
    margin-left: .5vw;
    height: 100%;
    width: 130px; 
    /* background-color: aqua; */
}
.buttontwo{
  display: flex;
  align-items: center;
  justify-content: center;
    height: 100%;
    width: 100%;
    color: white;
    background-color: #176282;
    border: 0;
    border-radius: 2px;
    font-size:.6vw;
    cursor: pointer;
}
.echarts{
    width: 100%;
    height: 85%;
    /* background-color: aquamarine; */
}
</style>